<template>
  <div v-if="bill.invoiceStatus === 'billed'">
    <button
        v-if="bill.coachingType === 'private_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'private_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'group_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'group_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'socio_therapy_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'socio_therapy_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'assisted_living_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'assisted_living_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'case_management_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'case_management_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'private_learning_coaching'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'private_learning_coaching')">
      {{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'special_case'"
        class="btn btn-primary"
        @click.prevent="cancellationBill(bill.id, 'special_case')">
      {{ $t('general.cancellation') }}
    </button>
  </div>
</template>

<script setup>
import { CloseToast } from '@/components/VueToast';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'billCancellation' ]);
const props = defineProps({
  bill: {
    type: Object,
    required: true,
  },
});

const cancellationBill = (id, billType) => {
  CloseToast();
  emit('billCancellation', id, billType);
};

</script>
